export default {
  notification: [],
  errorNotification: [],
};
